export default {
  notification: [],
  errorNotification: [],
};
